const selectValueByApiEnv = (e, d)=>d[e || 'fallback'];
export default selectValueByApiEnv;
